import * as React from 'react';

const Dashboard = () => {
  return (
      <div className="page-content">
          <h1 className="page-title">dashboard</h1>
      </div>
  );
};

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/Home/Dashboard.tsx